export default __webpack_public_path__ + "static/media/LMG.91af0356.svg";